import { type UVInsertConfig, isUvInsertUserConfigurableText } from '@shared/models/uv-inserts';

/**
 * Index of the first theme whose title contains `match` (case-insensitive), or -1.
 * @param {{ title: string }[]} themes - the config's theme variants
 * @param {string | null | undefined} match - text to look for, e.g. "christmas"
 * @returns {number}
 */
export function findThemeIndex(themes: { title: string }[], match: string | null | undefined): number {
  const needle = match?.toLowerCase();
  return needle ? themes.findIndex((theme) => (theme.title ?? '').toLowerCase().includes(needle)) : -1;
}

/**
 * `textByKey` with an entry for each of the config's text keys it lacks: blank for editable text, the fixed
 * value for read-only text. What the visualiser starts a card with.
 * @param {UVInsertConfig} config - the active card or insert config
 * @param {Record<string, string>} textByKey - text already entered, kept as is
 * @returns {Record<string, string>}
 */
export function seedTextByKey(config: UVInsertConfig, textByKey: Record<string, string>): Record<string, string> {
  const next = { ...textByKey };
  for (const face of config.faceElements) {
    for (const el of face.elementConfig) {
      if (isUvInsertUserConfigurableText(el) && !(el.lineItemPropertyKey in next)) {
        next[el.lineItemPropertyKey] = el.type === 'TEXT' && el.editable === false ? (el.value ?? '') : '';
      }
    }
  }
  return next;
}
